import { ITimelineCtrl } from "../omnia";

export class DomManager {

    private mouseDownEvent: MouseEvent;
    private mouseDragging: boolean;
    private dragScrollX: number;
    private dragScrollY: number;


    private listeners: { element: Node, type: string, lsnr: EventListener }[] = [];

    public readonly closePopup = {
        onClick: true
    }

    constructor(
        private apply: (stateChanged: boolean) => void,
        private rootElement: HTMLElement,
        private tl: ITimelineCtrl,
        private cropsContainerSelector: string,
        private syncScrollSelector?: string) {

        this.setup()

    }


    dispose() {

        this.listeners.forEach(l => {
            l.element.removeEventListener(l.type, l.lsnr);
        });

        this.listeners = [];
    }

    get isDragging(): boolean {
        return this.mouseDragging;
    }

    getState() {

        const crops = this.rootElement.querySelector(this.cropsContainerSelector)

        return {
            scrollLeft: crops.scrollLeft,
            scrollTop: crops.scrollTop
        }

    }

    setState(state: { scrollTop: number, scrollLeft: number }) {

        const crops = this.rootElement.querySelector(this.cropsContainerSelector)

        crops.scrollTop = state.scrollTop
        crops.scrollLeft = state.scrollLeft

    }

    private addListener(element: Node, type: string, lsnr: EventListener) {

        element.addEventListener(type, lsnr);

        this.listeners.push({ element: element, type: type, lsnr: lsnr });

    }

    private setup() {

        const { rootElement } = this

        const crops = rootElement.querySelector(this.cropsContainerSelector)
        const fields = rootElement.querySelector(".tl-fields")
        const dates = rootElement.querySelector(".tl-dates")

        this.addListener(rootElement, "click", () => {

            if (this.closePopup.onClick && this.tl.popupContext) {
                this.tl.popupContext = null;
                this.apply(true)
            }

        })

        this.addListener(crops, "scroll", e => {

            const left = crops.scrollLeft
            const top = crops.scrollTop

            fields.scrollTop = top
            dates.scrollLeft = left

            if (this.syncScrollSelector) {

                const s = rootElement.querySelectorAll(this.syncScrollSelector)

                s.forEach((i: HTMLElement) => {
                    i.style.left = left + "px"
                })

            }

            this.tl.popupContext = null

        })


        this.addListener(crops, "mousedown", (e: MouseEvent) => {
            this.mouseDownEvent = e;
            this.dragScrollX = crops.scrollLeft;
            this.dragScrollY = crops.scrollTop;
        });

        this.addListener(rootElement.ownerDocument, "mouseup", (e: MouseEvent) => {
            this.onMouseUp()
        });

        this.addListener(crops, "mousemove", (e: MouseEvent) => {

            if (e.button) {
                this.onMouseUp();
                return;
            }

            if (this.mouseDownEvent) {

                if (!this.mouseDragging) {

                    this.mouseDragging = true
                    this.tl.popupContext = null
                    this.apply(true)

                }

                const offsetX = this.mouseDownEvent.clientX - e.clientX
                const offsetY = this.mouseDownEvent.clientY - e.clientY

                crops.scrollLeft = dates.scrollLeft = this.dragScrollX + offsetX
                crops.scrollTop = this.dragScrollY + offsetY

            }

        });

        var wheel = (e: WheelEvent) => {


            if (e.altKey) {

                this.tl.setZoomLevelWheel(e.deltaY < 0 ? 0.1 : -0.1);
                this.apply(true)

            }
            else {
                crops.scrollLeft += e.deltaX;
                crops.scrollTop += e.deltaY;
            }

        };

        crops.addEventListener("wheel", wheel);
        fields.addEventListener("wheel", wheel);

    }

    private onMouseUp() {

        this.mouseDownEvent = null

        const chg = this.mouseDragging

        this.mouseDragging = false
        this.apply(chg)

    }

    setHorizontalScroll(x: number) {

        const crops = this.rootElement.querySelector(this.cropsContainerSelector)

        const viewportWidth = crops.clientWidth

        if (!viewportWidth) {

            setTimeout(() => {
                this.setHorizontalScroll(x)
            }, 100);

            return

        }

        x -= viewportWidth / 2;
        crops.scrollLeft = x;

    }

}
